const ICONS = {
  medicine:
    'M9 3h6v4H9V3zm-2 6h10a2 2 0 012 2v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8a2 2 0 012-2zm5 2v8m-4-4h8',
  house_clearance:
    'M4 20V10l8-6 8 6v10H4zm4-2h3v-5h2v5h3',
  morning_beauty:
    'M12 4v2m0 12v2M4 12H2m20 0h-2M6.3 6.3l1.4 1.4m8.6 8.6 1.4 1.4m0-11.4-1.4 1.4M7.7 16.3 6.3 17.7M12 8a4 4 0 100 8 4 4 0 000-8z',
  night_beauty:
    'M21 14.5A8.5 8.5 0 1110 3.5 7 7 0 0021 14.5z',
  call:
    'M6.5 3.5h3L11 7.5 9 9.2a12 12 0 005.8 5.8L16.5 13l4 1.5v3A2 2 0 0118.6 20 16 16 0 014 5.4 2 2 0 016.5 3.5z',
  drink_water:
    'M12 3s6 7.2 6 11.2A6 6 0 116 14.2C6 10.2 12 3 12 3z',
  workout:
    'M6 9v6M18 9v6M8 8h8v8H8V8zM4 10h2v4H4v-4zm14 0h2v4h-2v-4z',
  walk:
    'M13 5a2 2 0 11-4 0 2 2 0 014 0zM8 21l2-7 2 2 2 5M14 11l2 3 3 1M10 9l-2 4-3 1',
  meditation:
    'M12 5a2 2 0 110-4 2 2 0 010 4zM7 22l2-7h6l2 7M9 15l-3-3 3-2h6l3 2-3 3',
  pay_bills:
    'M6 3h12v18H6V3zm3 4h6M9 10h6M9 14h4',
  grocery:
    'M6 7h15l-1.5 9h-12L5 4H2m5 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z',
  sleep:
    'M4 12a8 8 0 008 8 8 8 0 007.5-10.5A7 7 0 0112 19 7 7 0 014 12z',
};

export function ReminderTemplateIcon({ id, className = 'w-6 h-6' }) {
  const d = ICONS[id] || ICONS.call;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export const REMINDER_TEMPLATES = [
  {
    id: 'medicine',
    label: 'Medicine',
    title: 'Take medicine',
    description: 'Take your dose on time with water.',
    recurrenceType: 'daily',
    time: '08:00',
    tasks: ['Take medicine', 'Drink a glass of water'],
    estimateMinutes: 5,
    color: 'text-red-600',
    bg: 'bg-red-50 dark:bg-red-950/40',
    active: 'bg-red-600',
  },
  {
    id: 'house_clearance',
    label: 'House clearance',
    title: 'House clearance',
    description: 'Quick tidy so the home stays clear.',
    recurrenceType: 'weekly',
    time: '10:00',
    daysOfWeek: ['SAT'],
    tasks: ['Tidy rooms', 'Wipe surfaces', 'Take out trash'],
    estimateMinutes: 45,
    color: 'text-amber-700',
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    active: 'bg-amber-700',
  },
  {
    id: 'morning_beauty',
    label: 'Morning beauty',
    title: 'Morning skincare',
    description: 'Morning beauty routine.',
    recurrenceType: 'daily',
    time: '07:30',
    tasks: ['Cleanser', 'Moisturizer', 'Sunscreen'],
    estimateMinutes: 15,
    color: 'text-orange-600',
    bg: 'bg-orange-50 dark:bg-orange-950/40',
    active: 'bg-orange-600',
  },
  {
    id: 'night_beauty',
    label: 'Night beauty',
    title: 'Night skincare',
    description: 'Night beauty routine before bed.',
    recurrenceType: 'daily',
    time: '21:30',
    tasks: ['Remove makeup', 'Cleanser', 'Night cream'],
    estimateMinutes: 15,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50 dark:bg-indigo-950/40',
    active: 'bg-indigo-600',
  },
  {
    id: 'call',
    label: 'Call',
    title: 'Make a call',
    description: 'Call the person you need to reach.',
    recurrenceType: 'once',
    time: '11:00',
    tasks: ['Make the call', 'Note what was discussed'],
    estimateMinutes: 15,
    color: 'text-green-600',
    bg: 'bg-green-50 dark:bg-green-950/40',
    active: 'bg-green-600',
  },
  {
    id: 'drink_water',
    label: 'Drink water',
    title: 'Drink water',
    description: 'Pause and hydrate.',
    recurrenceType: 'daily',
    time: '11:00',
    tasks: ['Drink a glass of water'],
    estimateMinutes: 5,
    color: 'text-sky-600',
    bg: 'bg-sky-50 dark:bg-sky-950/40',
    active: 'bg-sky-600',
  },
  {
    id: 'workout',
    label: 'Workout',
    title: 'Workout',
    description: 'Move your body today.',
    recurrenceType: 'daily',
    time: '06:30',
    tasks: ['Warm up', 'Workout', 'Stretch'],
    estimateMinutes: 30,
    color: 'text-orange-800',
    bg: 'bg-orange-50 dark:bg-orange-950/40',
    active: 'bg-orange-700',
  },
  {
    id: 'walk',
    label: 'Walk',
    title: 'Evening walk',
    description: 'Get outside for a walk.',
    recurrenceType: 'daily',
    time: '18:30',
    estimateMinutes: 20,
    color: 'text-emerald-700',
    bg: 'bg-emerald-50 dark:bg-emerald-950/40',
    active: 'bg-emerald-700',
  },
  {
    id: 'meditation',
    label: 'Meditation',
    title: 'Meditation',
    description: 'Quiet time to reset.',
    recurrenceType: 'daily',
    time: '07:00',
    tasks: ['Sit quietly', 'Breathe for 10 minutes'],
    estimateMinutes: 10,
    color: 'text-violet-700',
    bg: 'bg-violet-50 dark:bg-violet-950/40',
    active: 'bg-violet-700',
  },
  {
    id: 'pay_bills',
    label: 'Pay bills',
    title: 'Pay bills',
    description: 'Review and pay due bills.',
    recurrenceType: 'monthly',
    time: '10:00',
    daysOfMonth: [1],
    tasks: ['Check due bills', 'Pay and save receipts'],
    estimateMinutes: 20,
    color: 'text-amber-800',
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    active: 'bg-amber-800',
  },
  {
    id: 'grocery',
    label: 'Grocery',
    title: 'Grocery run',
    description: 'Restock kitchen and household items.',
    recurrenceType: 'weekly',
    time: '11:00',
    daysOfWeek: ['SUN'],
    tasks: ['Check pantry', 'Buy groceries', 'Put items away'],
    estimateMinutes: 40,
    color: 'text-green-800',
    bg: 'bg-green-50 dark:bg-green-950/40',
    active: 'bg-green-800',
  },
  {
    id: 'sleep',
    label: 'Sleep',
    title: 'Wind down for sleep',
    description: 'Start winding down so you sleep on time.',
    recurrenceType: 'daily',
    time: '22:30',
    tasks: ['Put phone away', 'Lights down'],
    estimateMinutes: 10,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50 dark:bg-indigo-950/40',
    active: 'bg-indigo-600',
  },
];
